<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="animated fadeIn vld-parent pb-1" style="height: 100%; background-color: #fcfcfc">
        <b-row>
            <b-col>
                <div style=" padding: 5px 32px 4px;border-bottom: 1px solid gray; ">
                    <b-row>
                        <b-col md="4">
                            <!--span style="font-weight: bolder">Baumnummer: {{next_tree_number}}</span-->
                            <b-row class="p-0">
                                <b-col class="my-auto "><span><b>Baumnummer:</b></span></b-col>
                                <b-col>
                                    <b-form-input class="form-control black font-weight-bold" type="text"
                                                  placeholder="Baumnummer"
                                                  v-model="next_tree_number"
                                    ></b-form-input>
                                </b-col>
                                <b-col md="6"></b-col>
                            </b-row>
                        </b-col>
                        <b-col></b-col>
                        <b-col xl="2" lg="3" md="4" sm="4">
                            <b-button variant="primary" class="px-4 float-right" v-on:click="onSave">Speichern
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <b-row style="padding-top: 1rem; padding-left: 15px; padding-right: 15px">
            <b-col md="6" style="padding-right: 7px">
                <md-card>
                    <md-card-header style="border-bottom: 1px solid lightgray;">
                        <span style="color: darkslategrey"><b>Baumbasisdaten</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        <b-row>
                            <b-col class="my-auto"><span>Baumname botanisch:</span></b-col>
                            <b-col>
                                <vue-bootstrap-typeahead
                                        id="tree_type_bot"
                                        ref="tree_type_bot"
                                        :minMatchingChars="0"
                                        placeholder="botanischer Name"
                                        v-model="basis_data.tree_type_bot"
                                        :data="auto_completes.tree_type_bot"
                                        @hit="onAutoComplete('bot', $event)"
                                        class="black"
                                        show-on-focus
                                />
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Baumname deutsch:</span></b-col>
                            <b-col>
                                <vue-bootstrap-typeahead
                                        id="tree_type_ger"
                                        ref="tree_type_ger"
                                        :minMatchingChars="0"
                                        placeholder="deutscher Name"
                                        v-model="basis_data.tree_type_ger"
                                        :data="auto_completes.tree_type_ger"
                                        @hit="onAutoComplete('ger', $event)"
                                        class="black"
                                        show-on-focus

                                />
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Planzjahr:</span></b-col>
                            <b-col>
                                <b-form-input class="form-control black" type="number"
                                              placeholder="z.B. 2014"
                                              v-model="basis_data.planting_year"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Geschätzte Lebensdauer:</span></b-col>
                            <b-col>
                                <b-form-input class="form-control black" type="number"
                                              placeholder="Lebensdauer in Jahren"
                                              v-model="basis_data.time_to_live"
                                ></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Baumhöhe:</span></b-col>
                            <b-col>
                                <b-form-input class="form-control black" type="number"
                                              placeholder="Baumhöhe in Metern"
                                              v-model="control_data.tree_height"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Kronendurchschnitt:</span></b-col>
                            <b-col>
                                <b-form-input class="form-control black" type="number"
                                              placeholder="Kronendurchschnitt in Metern"
                                              v-model="control_data.crown_mean"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Stammanzahl:</span></b-col>
                            <b-col>
                                <b-form-input class="form-control black" type="number"
                                              placeholder="Stammanzahl"
                                              v-model="control_data.trunk_count"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Stammdurchmesser:</span></b-col>
                            <b-col>
                                <b-form-input class="form-control black" type="number"
                                              placeholder="Stammdurchmesser in cm"
                                              v-model="control_data.trunk_diameter"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>
                <md-card style="margin-top: 16px">
                    <md-card-header style="border-bottom: 1px solid lightgray;">
                        <span style="color: darkslategrey"><b>Standort</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        <b-row>
                            <b-col class="my-auto"><span>Kommune:</span></b-col>
                            <b-col>
                                <vue-bootstrap-typeahead
                                        :minMatchingChars="0"
                                        placeholder="Kommune"
                                        v-model="location_data.commune"
                                        :data="auto_completes.commune"
                                        class="black"
                                        show-on-focus
                                />
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Tour:</span></b-col>
                            <b-col>
                                <vue-bootstrap-typeahead
                                        :minMatchingChars="0"
                                        placeholder="Tourname"
                                        v-model="location_data.tour"
                                        :data="auto_completes.tour"
                                        class="black"
                                        show-on-focus
                                />
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Ort:</span></b-col>
                            <b-col>
                                <vue-bootstrap-typeahead
                                        :minMatchingChars="0"
                                        placeholder="Ortsname"
                                        v-model="location_data.city"
                                        :data="auto_completes.city"
                                        class="black"
                                        show-on-focus
                                />
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Ortsteil:</span></b-col>
                            <b-col>
                                <vue-bootstrap-typeahead
                                        :minMatchingChars="0"
                                        placeholder="Ortsteil"
                                        v-model="location_data.district"
                                        :data="auto_completes.district"
                                        class="black"
                                        show-on-focus
                                />
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Gebiet:</span></b-col>
                            <b-col>
                                <vue-bootstrap-typeahead
                                        :minMatchingChars="0"
                                        placeholder="Gebiet"
                                        v-model="location_data.area"
                                        :data="auto_completes.area"
                                        class="black"
                                        show-on-focus
                                />
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Objekt Standort:</span></b-col>
                            <b-col>
                                <vue-bootstrap-typeahead
                                        :minMatchingChars="0"
                                        placeholder="z.B. Hauptstraße"
                                        v-model="location_data.object_location"
                                        :data="auto_completes.object_location"
                                        class="black"
                                        show-on-focus
                                />
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col md="6" class="my-auto"><span>Koordinaten:</span></b-col>
                            <b-col md="4">
                                <b-form-input class="form-control black" type="text"
                                              placeholder="Bitte über die Karte auswählen"
                                              v-model="latLon"
                                              disabled
                                              style="white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
color: black !important;"
                                ></b-form-input>
                            </b-col>
                            <b-col md="2">
                                <b-button variant="primary" v-on:click="toggleMapMode" class="px-4 float-right"
                                          v-if="!in_map_mode">Karte
                                </b-button>
                                <b-button variant="warning" v-on:click="toggleMapMode" class="px-4 float-right"
                                          v-if="in_map_mode">Weiter erfassen
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Stand:</span></b-col>
                            <b-col>
                                <vue-bootstrap-typeahead
                                        :minMatchingChars="0"
                                        placeholder="z.B. Straße"
                                        v-model="location_data.location"
                                        :data="auto_completes.location"
                                        class="black"
                                        show-on-focus
                                />
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Funktion:</span></b-col>
                            <b-col>
                                <vue-bootstrap-typeahead
                                        :minMatchingChars="0"
                                        placeholder="z.B. gestalterisch"
                                        v-model="location_data.function"
                                        :data="auto_completes.function"
                                        class="black"
                                        show-on-focus
                                />
                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>
            </b-col>
            <b-col md="6" style="padding-left: 7px">
                <md-card style="padding-bottom: 10px" v-if="!in_map_mode">
                    <md-card-header style="border-bottom: 1px solid lightgray;">
                        <span style="color: darkslategrey"><b>Baumstatus</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        <b-row>
                            <b-col class="my-auto"><span>Vitalitätsstatus:</span></b-col>
                            <b-col>
                                <b-form-select plain v-model="control_data.vitality" :options="auto_completes.vitality"
                                               class="black"
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Bitte auswählen --
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Verkehrssicher:</span></b-col>
                            <b-col>
                                <b-form-select plain v-model="control_data.verkehrssicher"
                                               :options="auto_completes.verkehrssicher"
                                               class="black"
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Bitte auswählen --
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Entwicklungsphase:</span></b-col>
                            <b-col>
                                <b-form-select plain v-model="status_data.growing_state"
                                               :options="selects.growing_state"
                                               value-field="id"
                                               class="black"

                                               @change="onIntervalPrerequisiteChange">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Bitte auswählen --
                                        </b-form-select-option>
                                    </template>

                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Sicherheitserwartung:</span></b-col>
                            <b-col>
                                <b-form-select plain v-model="status_data.security_expectation"
                                               :options="selects.security_expectation"
                                               @change="onIntervalPrerequisiteChange"
                                               class="black"
                                               value-field="id">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Bitte auswählen --
                                        </b-form-select-option>
                                    </template>

                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Zustand:</span></b-col>
                            <b-col>
                                <b-form-select plain v-model="status_data.condition" :options="selects.condition"
                                               @change="onIntervalPrerequisiteChange"
                                               class="black"
                                               value-field="id">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Bitte auswählen --
                                        </b-form-select-option>
                                    </template>

                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Kontrollintervall:</span></b-col>
                            <b-col>
                                <b-form-select plain v-model="status_data.control_interval"
                                               :options="selects.control_interval"
                                               class="black"
                                               value-field="id"
                                               @input="onControlInterval">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Wird automatisch gesetzt --
                                        </b-form-select-option>
                                    </template>

                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3 pt-4" style="border-top: 1px solid lightgray">
                            <b-col class="my-auto"><span>Letzte Kontrolle:</span></b-col>
                            <b-col>
                                <datetime
                                        v-model="status_data.last_control"
                                        input-class="form-control"
                                        input-style="color: black;"
                                        input-id="date_last"
                                        :phrases="datetimeConfigLast.phrases"
                                        :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                                ></datetime>
                            </b-col>
                            <b-col class="my-auto"><span>Nächste Kontrolle:</span></b-col>
                            <b-col>
                                <datetime
                                        v-model="status_data.next_control"
                                        input-class="form-control"
                                        input-style="color: black;"
                                        input-id="date_next"
                                        :phrases="datetimeConfigNext.phrases"
                                        :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                                        :min-datetime="datetimeConfigNext.minTime"
                                ></datetime>
                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>

                <md-card style="margin-top: 16px" v-if="!in_map_mode">
                    <md-card-header style="border-bottom: 1px solid lightgray;">
                        <span style="color: darkslategrey"><b>Zusatz Informationen</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        <b-row>
                            <b-col>
                                <span>Stammauftrag:</span>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col>
                                <b-form-select                                         class="black"
                                                                                       plain v-model="augr"
                                                                                       :disabled="disabled"
                                                                                       :options="augrs"
                                                                                       @change="onAugrChanged"
                                                                                       value-field="s_value_2"
                                                                                       text-field="s_value">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Bitte auswählen --
                                        </b-form-select-option>
                                    </template>

                                </b-form-select>
                            </b-col>
                            <b-col>
                                <b-form-select                                         class="black"
                                                                                       plain v-model="aufisn"
                                                                                       :disabled="disabled || augr === null"
                                                                                       :options="aufisns"
                                                                                       @change="onAufisnChanged"
                                                                                       text-field="s_value"
                                                                                       value-field="s_value_2">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Bitte auswählen --
                                        </b-form-select-option>
                                    </template>

                                </b-form-select>
                            </b-col>
                        </b-row>
                      <b-row class="mt-3 pt-2 border-top">
                        <b-col class="my-auto"><span>Artenschutzrelevant:</span></b-col>
                        <b-col>
                          <b-form-select plain v-model="pos_relevant" :options="pos_relevant_options"
                                         class="black"
                          >
                          </b-form-select>
                        </b-col>
                      </b-row>
                        <b-row class="mt-3 pt-2 border-top">
                            <b-col md="6" lg="8">
                                <span style="margin-left: 6px;">Notizen:</span>
                                <b-form-textarea style="margin-top: 16px"
                                                 placeholder="Tragen Sie hier ihre Notizen/Hinweise für diesen Baum ein."
                                                 rows="10"
                                                 no-resize
                                                 v-model="note"
                                                 class="black"
                                ></b-form-textarea>
                            </b-col>
                            <b-col md="6" lg="4">
                                <span style="margin-left: 18px">Foto:</span>
                                <picture-input style="margin-top: 16px"
                                               ref="pictureInput"
                                               width="300"
                                               height="300"
                                               removable
                                               :customStrings="picture_config"
                                               accept="image/jpeg,image/png"
                                               size="10"
                                               :hideChangeButton="true"
                                />
                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>

                <md-card v-if="in_map_mode">
                    <md-card-header style="border-bottom: 1px solid lightgray;">
                        <b-row>
                            <b-col class="my-auto">
                                <span style="color: darkslategrey"><b>Karte</b></span>
                            </b-col>
                            <b-col md="4">
                                <b-button variant="warning" v-on:click="toggleMapMode" class="px-4 float-right"
                                          v-if="in_map_mode">Weiter erfassen
                                </b-button>
                            </b-col>
                        </b-row>
                    </md-card-header>
                    <md-card-content style="margin-top: 0px; padding-bottom: 0">
                        <b-row style="margin-bottom: 0">
                            <b-col style="height: 80vh; padding: 0; margin-bottom: 0" id="map_container"
                                   ref="map_container">
                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>

            </b-col>
        </b-row>

    </div>
</template>

<script>
    import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'
    import {DateTime as LuxonDateTime} from 'luxon'
    import {Server_URL} from "../../shared/utils";
    import PictureInput from './PictureInput'

    import StylesControl from 'mapbox-gl-controls/lib/styles';
    import ZoomControl from 'mapbox-gl-controls/lib/zoom';
    import LanguageControl from 'mapbox-gl-controls/lib/language';
    import MapboxGeocoder from 'mapbox-gl-geocoder';
    import mapboxgl from 'mapbox-gl/dist/mapbox-gl';

    export default {
        name: "TreeForm",
        components: {VueBootstrapTypeahead, PictureInput},
        mounted() {
            this.showLoader();
            this.$http.get(
                Server_URL + '/baumkontrolle/create_tree'
            ).then(this.responseOkGet, this.responseError)
        },
        data() {
            return {
                isInit: false,
                geocoder: null,
                map: {},
                marker: null,
                loader: undefined,
                lat: null,
                lon: null,
                in_map_mode: false,
                image_name: null,
                basis_data: {
                    tree_type_bot: "",
                    tree_type_ger: "",
                    planting_year: "",
                    time_to_live: "",
                },
                status_data: {
                    growing_state: null,
                    condition: null,
                    security_expectation: null,
                    control_interval: null,
                    next_control: null,
                    last_control: null,
                },
                location_data: {
                    commune: "",
                    tour: "",
                    city: "",
                    district: "",
                    area: "",
                    object_location: "",
                    location: "",
                    function: "",
                },
                note: "",
                control_data: {
                    vitality: null,
                    verkehrssicher: null,
                    tree_height: "",
                    crown_mean: "",
                    trunk_count: "",
                    trunk_diameter: "",
                },
                datetimeConfigNext: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
                datetimeConfigLast: {phrases: {ok: 'Ok', cancel: 'Abbruch'}},
                auto_completes: {
                    tree_type_bot: [],
                    tree_type_ger: [],
                    commune: [],
                    tour: [],
                    city: [],
                    district: [],
                    area: [],
                    object_location: [],
                    location: [],
                    function: [],
                    vitality: [],
                    verkehrssicher: [],
                },
                selects: {
                    security_expectation: [],
                    growing_state: [],
                    condition: [],
                    control_interval: [],
                },
                interval_relations: [],
                next_tree_number: 1,
                can_define_tree_number: false,

              pos_relevant: false,
              pos_relevant_options: [{value: false, text: "Nein"}, {value: true, text: "Ja"}],

                picture_config: {
                    upload: '<p>Ihr Geraet unterstuetzt keinen Foto-Upload.</p>', // HTML allowed
                    drag: 'Hier klicken <br>um ein Foto <br>auszuwählen', // HTML allowed
                    tap: 'Hier klicken <br>um ein Foto <br>auszuwählen', // HTML allowed
                    change: 'Foto ändern', // Text only
                    remove: 'Foto entfernen', // Text only
                    select: 'Foto auswählen', // Text only
                    selected: '<p>Foto erfolgreich ausgewählt!</p>', // HTML allowed
                    fileSize: 'Die Datei ist zu gross.', // Text only
                    fileType: 'Dieser Dateityp wird nicht unterstuetzt.'
                },
                augrs: [],
                augr: null,
                aufisns: [],
                aufisn: null,
                augr_map: [],
                task_group: null,
                task: null,

            }
        },
        computed: {
            latLon: function () {
                if (this.lat != null && this.lon != null) {
                    return this.lat.toString() + ", " + this.lon.toString();
                } else {
                    return "";
                }
            }
        },
        methods: {
            onAugrChanged() {
                for (let i = 0; i < this.augrs.length; i++) {
                    if (this.augrs[i].s_value_2 === this.augr) {
                        this.task_group = this.augrs[i];
                        break;
                    }
                }
                this.aufisn = null;
                this.task = null;
                this.aufisns = this.augr_map[this.task_group.s_value];
            },
            onAufisnChanged() {
                for (let i = 0; i < this.aufisns.length; i++) {
                    if (this.aufisns[i].s_value_2 === this.aufisn) {
                        this.task = this.aufisns[i];
                    }
                }
            },
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            log() {
            },
            onAutoComplete(type, input) {
                if (type === 'bot') {
                    for (let i = 0; i < this.auto_completes.tree_type_bot.length; i++) {
                        if (this.auto_completes.tree_type_bot[i] === input) {
                            this.basis_data.tree_type_ger = this.auto_completes.tree_type_ger[i];
                            this.$refs.tree_type_ger.$refs.input.value = this.basis_data.tree_type_ger;
                            break;
                        }
                    }
                } else {
                    for (let i = 0; i < this.auto_completes.tree_type_ger.length; i++) {
                        if (this.auto_completes.tree_type_ger[i] === input) {
                            this.basis_data.tree_type_bot = this.auto_completes.tree_type_bot[i];
                            this.$refs.tree_type_bot.$refs.input.value = this.basis_data.tree_type_bot;
                            break;
                        }
                    }
                }
            },
            onIntervalPrerequisiteChange() {
                for (let i = 0; i < this.interval_relations.length; i++) {
                    let current = this.interval_relations[i];
                    if (current.control_interval !== 0) {
                        if ((current.condition.includes("|" + this.status_data.condition + "|") || current.condition === "") &&
                            (current.growing_state.includes("|" + this.status_data.growing_state + "|") || current.growing_state === "") &&
                            (current.security_expectation.includes("|" + this.status_data.security_expectation + "|") || current.security_expectation === "")) {
                            this.status_data.control_interval = current.control_interval;
                            break;
                        }
                    }
                }
            },
            onControlInterval() {
                for (let i = 0; i < this.selects.control_interval.length; i++) {
                    if (this.selects.control_interval[i].id === this.status_data.control_interval) {
                        if (this.selects.control_interval[i].value !== 0) {
                            this.status_data.next_control = LuxonDateTime.local().plus({years: this.selects.control_interval[i].value}).toISO();
                        }
                        break;
                    }
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    console.log(response.body);
                    this.next_tree_number = response.body.next_tree_number;
                    this.can_define_tree_number = response.body.can_define_tree_number;
                    this.selects.security_expectation = response.body.security_expectation;
                    this.selects.growing_state = response.body.growing_state;
                    this.selects.condition = response.body.condition;
                    this.selects.control_interval = response.body.control_interval;
                    this.auto_completes.tree_type_bot = response.body.tree_type_bot;
                    this.auto_completes.tree_type_ger = response.body.tree_type_ger;
                    this.auto_completes.commune = response.body.commune;
                    this.auto_completes.tour = response.body.tour;
                    this.auto_completes.city = response.body.city;
                    this.auto_completes.district = response.body.district;
                    this.auto_completes.area = response.body.area;
                    this.auto_completes.object_location = response.body.object_location;
                    this.auto_completes.location = response.body.location;
                    this.auto_completes.function = response.body.function;
                    this.auto_completes.vitality = response.body.vitality;
                    this.auto_completes.verkehrssicher = response.body.verkehrssicher;
                    this.interval_relations = response.body.interval_relations;
                    this.augrs = response.data.augr;
                    this.augr_map = response.data.augr_map;
                    let def_task = response.data.default_task.length > 0 ? response.data.default_task[0] : null;
                    if (def_task !== null) {
                        for (let i = 0; i < this.augrs.length; i++) {
                            if (this.augrs[i].s_value_2 === def_task.s_value) {
                                this.task_group = this.augrs[i];
                                this.aufisns = this.augr_map[this.task_group.s_value];
                                this.augr = this.task_group.s_value_2;
                                break;
                            }
                        }
                        for (let i = 0; i < this.aufisns.length; i++) {
                            if (this.aufisns[i].s_value_2 === def_task.s_value_2) {
                                this.task = this.aufisns[i];
                                this.aufisn = this.task.s_value_2;
                                break;
                            }
                        }
                    }

                } else {
                    console.log(response);
                }
            },
            responseOkCreate(response) {
                this.hideLoader();
                if (response.status === 200) {
                    if (this.image_name !== null) {
                        this.showLoader();
                        let temp = this.image_name;
                        this.image_name = null;
                        let formData = new FormData();
                        formData.append('file', this.$refs.pictureInput.file);
                        this.$http.post(
                            Server_URL + '/baumkontrolle/create_tree/image' + "?tree_id="+response.data.id+"&image_name="+temp,
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }
                        ).then(this.responseOkCreate, this.responseError);
                    } else {
                        location.reload();
                    }
                } else {
                    console.log(response);
                }
            },

            onMapClick(e) {
                this.lat = e.lngLat.lat;
                this.lon = e.lngLat.lng;

                if (this.marker === null) {
                    let el = document.createElement('div');
                    el.className = 'marker';

                    this.marker = new mapboxgl.Marker({
                        element: el,
                        anchor: 'bottom',
                    })
                        .setLngLat([this.lon, this.lat])
                        .addTo(this.map);
                } else {
                    this.marker.setLngLat([this.lon, this.lat])
                }
            },
            toggleMapMode() {
                let current = this.in_map_mode;
                this.in_map_mode = !this.in_map_mode;
                if (!current) {
                    setTimeout(() => {
                        mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
                        this.map = new mapboxgl.Map({
                            container: 'map_container',
                            style: 'mapbox://styles/mapbox/satellite-streets-v11',
                            center: [10.244990, 50.943359],
                            zoom: 6,
                            minZoom: 5,
                            maxPitch: 0,
                        });

                        this.map.addControl(new StylesControl({
                            styles: [
                                {
                                    label: 'Normal',
                                    styleName: 'Mapbox Streets',
                                    styleUrl: 'mapbox://styles/mapbox/outdoors-v11',
                                }, {
                                    label: 'Satellit',
                                    styleName: 'Satellite',
                                    styleUrl: 'mapbox://styles/mapbox/satellite-streets-v11',
                                },
                            ],
                        }), 'top-left');
                        this.map.addControl(new ZoomControl(), 'bottom-right');
                        const languageControl = new LanguageControl({
                            language: 'de',
                        });
                        this.map.addControl(languageControl);
                        this.geocoder = new MapboxGeocoder({
                            accessToken: mapboxgl.accessToken,
                            mapboxgl: mapboxgl,
                            placeholder: "Suchen"
                        });
                        this.map.addControl(
                            this.geocoder
                        );

                        this.map.on('click', this.onMapClick);
                        this.map.once('load', this.queryPlace)
                    });
                } else {
                    this.map.remove();
                }
            },
            queryPlace() {
                if (this.lat !== null && this.lon !== null) {
                    let el = document.createElement('div');
                    el.className = 'marker';

                    this.marker = new mapboxgl.Marker({
                        element: el,
                        anchor: 'bottom',
                    })
                        .setLngLat([this.lon, this.lat])
                        .addTo(this.map);
                    this.map.flyTo({
                        center: [
                            this.lon,
                            this.lat
                        ],
                        zoom: 18,
                        essential: true // this animation is considered essential with respect to prefers-reduced-motion
                    });
                } else if (this.location_data.commune != "" || this.location_data.city != "" || this.location_data.object_location !== "") {
                    this.geocoder.query("" + this.location_data.commune + ", " + this.location_data.city + ", " + this.location_data.object_location);
                }
            },
            makeid(length) {
                var result = '';
                var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var charactersLength = characters.length;
                for (var i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
            },
            onSave() {
               let imageName = "";
                if (this.$refs.pictureInput.file !== undefined && this.$refs.pictureInput.file !== null) {
                    console.log(this.$refs.pictureInput.file);
                    imageName = this.makeid(6);
                    this.image_name = imageName;
                    imageName +=  "||";
                }
                let tree = {
                    tree_number: this.next_tree_number.trim(),
                    tree_type_bot: this.basis_data.tree_type_bot.trim(),
                    tree_type_ger: this.basis_data.tree_type_ger.trim(),
                    growing_state: this.status_data.growing_state,
                    verkehrssicher: this.control_data.verkehrssicher === null ? null : this.control_data.verkehrssicher.trim(),
                    condition: this.status_data.condition,
                    vitality_status: this.control_data.vitality === null ? null : this.control_data.vitality.trim(),
                    security_expectation: this.status_data.security_expectation,
                    time_to_live: Number.isNaN(parseInt(this.basis_data.time_to_live)) ? 0 : parseInt(this.basis_data.time_to_live),
                    planting_year: Number.isNaN(parseInt(this.basis_data.planting_year)) ? 0 : parseInt(this.basis_data.planting_year),
                    note: this.note.trim(),
                    control_interval: this.status_data.control_interval,
                    next_control: this.status_data.next_control === "" ? null : this.status_data.next_control,
                    last_control: this.status_data.last_control === "" ? null : this.status_data.last_control,
                    commune: this.location_data.commune.trim(),
                    tour: this.location_data.tour.trim(),
                    city: this.location_data.city.trim(),
                    district: this.location_data.district.trim(),
                    area: this.location_data.area.trim(),
                    object_location: this.location_data.object_location.trim(),
                    location: this.location_data.location.trim(),
                    function: this.location_data.function.trim(),
                    tree_height: Number.isNaN(parseFloat(this.control_data.tree_height)) ? 0.0 : parseFloat(this.control_data.tree_height),
                    crown_mean: Number.isNaN(parseFloat(this.control_data.crown_mean)) ? 0.0 : parseFloat(this.control_data.crown_mean),
                    trunk_count: Number.isNaN(parseInt(this.control_data.trunk_count)) ? 0 : parseInt(this.control_data.trunk_count),
                    trunk_diameter: Number.isNaN(parseInt(this.control_data.trunk_diameter)) ? 0 : parseInt(this.control_data.trunk_diameter),
                    lat: this.lat,
                    lon: this.lon,
                    image_url: imageName,
                    augr: (this.task_group !== null && this.task !== null) ? this.task_group.s_value_2 : null,
                    aufisn: (this.task_group !== null && this.task !== null) ? this.task.s_value_2 : null,
                    hh: "",
                    stammauftrag: (this.task_group !== null && this.task !== null) ? this.task.s_value : null,
                  pos_relevant: this.pos_relevant,
                };

                this.$http.post(
                    Server_URL + '/baumkontrolle/create_tree', JSON.stringify(tree)
                ).then(this.responseOkCreate, this.responseError);
            }
        }
    }
</script>

<style>
    .marker {
        background-image: url('../../../public/tree_marker.png');
        background-size: cover;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        cursor: pointer;
    }

    .md-card {
        z-index: unset;
    }

    .black .input-group .form-control {
        color: #23282c;
    }
</style>

<style scoped>
    @import '../../../node_modules/vue-material/dist/vue-material.min.css';
</style>
